<template>
  <div class="float-element">
    <div :class="isQQshow ? 'activeZxdh zxdh_l element_l': !isActive ? 'neiBg zxdh_l element_l' : 'zxdh_l element_l'" @click="toShowQQ">
      <img src="../assets/img/weixin.png" class="zx_img">
      <span>微信</span>
      <div class="zxdh" v-if="isQQshow">
        {{ this.assistForm.weChat }}
      </div>
    </div>
    <div :class="zxdhShow ? 'activeZxdh zxdh_l element_l': !isActive ? 'neiBg zxdh_l element_l' : 'zxdh_l element_l'" @click="toShowZxdh">
      <img src="../assets/img/zxdh.png" class="dh_img">
      <span>咨询电话</span>
      <div class="zxdh" v-if="zxdhShow">
        <a :href="'tel:'+this.assistForm.zxPhone" v-if="pageWidth <= 1280">{{this.assistForm.zxPhone}}</a>
        <span v-else>{{this.assistForm.zxPhone}}</span>
      </div>
    </div>
    <div class="element_l" @click="toMessageBoard()" :style="{background: !isActive? '#1D3559':'rgba(82, 128, 182, 0.2)'}">
      <img src="../assets/img/lyb.png" class="ly_img">
      <span>留言板</span>
    </div>
    <div class="element_l_S" @click="goTop" v-if="showTop" :style="{background: !isActive? '#1D3559':'rgba(82, 128, 182, 0.2)'}">
      <img src="../assets/img/go_up.png" class="fh_img">
      <span>返回顶部</span>
    </div>

  </div>
</template>
<script>
export default {
  name: "index",
  components: {},
  data() {
    return {
      pageWidth: 0,
      isQQshow: false,
      zxdhShow: false,
      assistForm: {
        phone: '',
        email: '',
        zxPhone: '',
        qq: '',
        fwkhValue: '',
        rzzlValue: '',
        phoneZc: '',
        phoneZcTime: '',
        emailZc: '',
        emailZcTime: '',
        remoteZcTime: '',
        xcZc: '',
        aboutUsInfo: '',
        weChat: ''
      },
    }
  },
  props: {
    showTop: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  mounted: function () {
    this.pageWidth = document.documentElement.clientWidth
  },
  created() {
    this.getauxiliaryinfo()
  },
  methods: {
    // 唤起拨打电话
    toTel() {
      if(this.pageWidth <= 1280) {
        window.location.href = 'tel:' + this.assistForm.zxPhone;
      }
    },
    // 获取辅助参数
    getauxiliaryinfo() {
      this.$API.InterfaceConfigurationPage._getauxiliaryinfo().then(res => {
        if (res.success) {
          if (res.data.length > 0) {
            res.data.forEach(item => {
              if (item.name == '电话') {
                this.assistForm.phone = item.value
              }
              if (item.name == '邮箱') {
                this.assistForm.email = item.value
              }
              if (item.name == '咨询电话') {
                this.assistForm.zxPhone = item.value
              }
              if (item.name == 'QQ') {
                this.assistForm.qq = item.value
              }
              if (item.name == '服务客户') {
                this.assistForm.fwkhValue = item.value
              }
              if (item.name == '软著专利资质') {
                this.assistForm.rzzlValue = item.value
              }
              if (item.name == '电话支持') {
                this.assistForm.phoneZc = item.value
              }
              if (item.name == '电话支持时间') {
                this.assistForm.phoneZcTime = item.value
              }
              if (item.name == 'E-mail支持') {
                this.assistForm.emailZc = item.value
              }
              if (item.name == 'E-mail支持时间') {
                this.assistForm.emailZcTime = item.value
              }
              if (item.name == '远程支持时间') {
                this.assistForm.remoteZcTime = item.value
              }
              if (item.name == '现场支持') {
                this.assistForm.xcZc = item.value
              }
              if (item.name == '关于我们') {
                this.assistForm.aboutUsInfo = item.value
              }
              if (item.name == 'WeChat') {
                this.assistForm.weChat = item.value
              }
            })
          }
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 留言板
    toMessageBoard() {
      let routeData = this.$router.resolve({ path: '/messageBoard'});
      window.open(routeData.href, '_blank');
      // this.$router.push({path: '/messageBoard'})
    },
    // 咨询电话
    toShowZxdh() {
      this.zxdhShow = !this.zxdhShow
      this.isQQshow = false
    },
    // QQ
    toShowQQ() {
      this.isQQshow = !this.isQQshow
      this.zxdhShow = false
    },
    // 回到顶部
    goTop() {
      // 使用 window.scrollTo 将页面滚动位置设为顶部
      window.scrollTo(0, 0);
    },
  }
}
</script>
<style scoped lang="less">
@import "../assets/css/floatElement.less";

</style>



// WEBPACK FOOTER //
// src/components/floatElement.vue